import type { BackupVault } from '@repo/api-gw-sdk';
import { useState } from 'react';

import { KMSKeyEditorPanel } from './kmsKeyEditorPanel';

import { ChangeableTextField } from '../text/changeableTextField';

export const AwsKmsTextField = ({
  backupVault,
  setBackupVault,
}: {
  backupVault: BackupVault;
  setBackupVault: (data: BackupVault) => void;
}) => {
  const [openKmsKeyEditor, setOpenKmsKeyEditor] = useState(false);
  const encryptionKey = backupVault.vaultAttributes.aws?.encryptionKey;

  return (
    <>
      <ChangeableTextField
        value={encryptionKey}
        onClick={() => setOpenKmsKeyEditor(true)}
        placeholder='No key set'
        noValueButtonText='Set Key'
      />
      <KMSKeyEditorPanel
        open={openKmsKeyEditor}
        onClose={() => setOpenKmsKeyEditor(false)}
        data={backupVault}
        setData={setBackupVault}
      />
    </>
  );
};
